export { MultiSelect } from './MultiSelect'
export type { MultiSelectProps, Option } from './interfaces/multiselect'
